import { Component, ViewChild } from '@angular/core';
import { ViewCompetitorsComponent } from './view.competitors.component';
import { CompetitorAwardsComponent } from './competitor.awards.component';
import { CompetitorAwardSearchStorage } from '../../models/competitors/competitor.models';
import { LoggedInUserService, LoggedInUser } from '../../auth/logged.in.user';
import { BaseCompetitorsComponent } from './base.competitors.component';
import { CompetitorService } from '../../services/competitor.service';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';
import { AddCompetitorsComponent } from './add.competitors.component';
import { CompetitorAwardsService } from '../../services/competitor.awards.service';
import { AwardDto, CompetitorAwardsSearchModel } from '../../models/competitors/competitor.models';
import { IPage } from '../../models/common/paging';

@Component({
    selector: 'competitors',
    template: require('./competitors.component.html'),
    styles: [require('./competitors.component.css')]
})
export class CompetitorsComponent {
    @ViewChild(ViewCompetitorsComponent, { static: false }) viewChild: ViewCompetitorsComponent;
    @ViewChild(CompetitorAwardsComponent, { static: false }) awardsChild: CompetitorAwardsComponent;
    @ViewChild(AddCompetitorsComponent, { static: false }) addChild: AddCompetitorsComponent;

    activeTab = 'search';
    selectedTabIndex: number = 0;
    isExpanded: boolean = true;
    monitorCount: number = 0;
    outsideAwardsRequest: CompetitorAwardsSearchModel;
    outsideAwards: IPage<AwardDto>;
    private readonly user: LoggedInUser;
    base: BaseCompetitorsComponent;
    dialogName: string;
    dialogHeader: string;
    dialogBody: string;
    subscribed: boolean;

    constructor(private readonly loggedInUserService: LoggedInUserService,
        private readonly competitorService: CompetitorService,
        private readonly competitorAwardsService: CompetitorAwardsService,
        private readonly configuration: Configuration,
        helpers: Helpers,
        private readonly cmsDialogService: CmsDialogService) {
        this.user = loggedInUserService.getCurrentUser();
        this.subscribed = !this.user.canAdHoc('notSubscribed');
        this.base = new BaseCompetitorsComponent(competitorService, this.configuration, helpers);

        this.outsideAwardsRequest = new CompetitorAwardsSearchModel(this.configuration);
        this.outsideAwardsRequest.pageNumber = 0;
        this.outsideAwardsRequest.pageSize = 10;
    }

    ngOnInit() {

        if (this.base.hasCompetitors()) {
            this.activeTab = 'search';
        }
        else {
            this.activeTab = this.teamMember() ? 'current' : 'search';
        }

        if (this.teamMember()) {
            this.activeTab = 'current';
        }

        this.selectedTabIndex = this.getTabIndex(this.activeTab);
        this.refreshMonitorCount();
        this.refreshOutsideAwards();

        if (this.subscribed) {
            this.dialogName = 'Competitors Info - Subscribed';
        }
        else {
            this.dialogName = 'Competitors Info - Not Subscribed';
        }

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        const storedRequest = JSON.parse(localStorage.getItem('awardStore')) as CompetitorAwardSearchStorage;

        if (storedRequest) {
            //localStorage.removeItem('awardStore');
            //this.activeTab = 'awards';
        }

    }

    togglePanel(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isExpanded = !this.isExpanded;
    }

    private refreshMonitorCount() {
        this.competitorService.getCompetitors().subscribe((response: string[]) => {
            this.monitorCount = response ? response.length : 0;
        });
    }

    private refreshOutsideAwards() {
        this.competitorAwardsService.search(this.outsideAwardsRequest).subscribe((results: IPage<AwardDto>) => {
            this.outsideAwards = results;
        });
    }

    onTabIndexChange(index: number) {
        this.selectedTabIndex = index;
        this.activeTab = this.getTabName(index);
    }

    private getTabName(index: number): string {
        var tabs = this.getVisibleTabs();
        if (index < 0 || index >= tabs.length) {
            return tabs[0];
        }
        return tabs[index];
    }

    private getTabIndex(tabName: string): number {
        var tabs = this.getVisibleTabs();
        var idx = tabs.indexOf(tabName);
        return idx >= 0 ? idx : 0;
    }

    private getVisibleTabs(): string[] {
        return this.teamMember()
            ? ['awards', 'current']
            : ['search', 'awards', 'current'];
    }

    ngOnDestroy() {
        $('#competitors-info-modal').modal('hide');
    }

    refresh() {
        this.viewChild.refresh();
        this.refreshAwards();
        this.refreshMonitorCount();
        this.refreshOutsideAwards();
    }

    refreshAwards() {
        this.awardsChild.refresh();
        this.addChild.search();
        this.refreshMonitorCount();
        this.refreshOutsideAwards();
    }

    showAwardsTab() {
        this.refreshAwards();
        this.activeTab = 'awards';
        this.selectedTabIndex = this.getTabIndex('awards');
    }

    teamMember(): boolean {
        return (this.user.role != 'Supplier');
    }

    showInfoDialog() {
        $('#competitors-info-modal').modal();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitors.component.ts